import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    height: '100%',

    '& .column-content': {
      borderRight: `solid 1px ${theme.palette.divider}`,
      height: '100%',
    },
  },
}));

export default styles;
